import { PurchaseData, Instrument, Issuer, TransactionCallbackResponse } from "./types";

export const DEFAULT = "DEFAULT";

export interface DefaultAction {
  type: typeof DEFAULT;
}

//#region Load Purchase Data

export const LOADING_PURCHASE_DATA = "LOADING_PURCHASE_DATA";
export const LOAD_PURCHASE_DATA_SUCCESS = "LOAD_PURCHASE_DATA_SUCCESS";
export const LOAD_PURCHASE_DATA_FAILED = "LOAD_PURCHASE_DATA_FAILED";

export interface LoadingPurchaseDataAction {
  type: typeof LOADING_PURCHASE_DATA;
  sessionId: string;
}

export interface LoadPurchaseDataSuccessAction {
  type: typeof LOAD_PURCHASE_DATA_SUCCESS;
  data: PurchaseData;
}

export interface LoadPurchaseDataFailedAction {
  type: typeof LOAD_PURCHASE_DATA_FAILED;
  error: string;
}

export type PurchaseDataTypes =
  | LoadingPurchaseDataAction
  | LoadPurchaseDataSuccessAction
  | LoadPurchaseDataFailedAction;

//#endregion

//#region Purchase

export const PURCHASING = "PURCHASING";
export const PURCHASE_SUCCESS = "PURCHASE_SUCCESS";
export const PURCHASE_FAILED = "PURCHASE_FAILED";
export const TRANSACTION_CALLBACK = "TRANSACTION_CALLBACK";
export const PAGE_REDIRECTED = "PAGE_REDIRECTED";
export const GENERATE_PAYMENT_LINK = "GENERATE_PAYMENT_LINK";

export interface PurchasingAction {
  type: typeof PURCHASING;
}

export interface PurchaseSuccessAction {
  type: typeof PURCHASE_SUCCESS;
  transactionCallbackResponse: TransactionCallbackResponse;
}

export interface PurchaseFailedAction {
  type: typeof PURCHASE_FAILED;
  error: string;
  transactionCallbackResponse?: TransactionCallbackResponse | null;
}

export type TransactionCallbackType = {
  type: typeof TRANSACTION_CALLBACK;
  //do we need any more info?
};

export type PageRedirectedType = {
  type: typeof PAGE_REDIRECTED;
  sessionId: string;
}

export type GeneratePaymentLinkType = {
  type: typeof GENERATE_PAYMENT_LINK;
  amount: Number;
  secret: String;
  callback: any;
}

//#endregion

export type PurchaseTypes =
  | PurchasingAction
  | PurchaseSuccessAction
  | PurchaseFailedAction
  | TransactionCallbackType
  | PageRedirectedType;

//#region Get Plexo URL

export const GETTING_URL = "GETTING_URL";
export const GET_URL_SUCCESS = "GET_URL_SUCCESS";
export const GET_URL_ERROR = "GET_URL_ERROR";

export interface GettingUrlAction {
  type: typeof GETTING_URL;
}

export interface GetUrlSuccessAction {
  type: typeof GET_URL_SUCCESS;
  url: string;
  sessionId: string;
}

export interface GetUrlErrorAction {
  type: typeof GET_URL_ERROR;
  error: string;
}

export type GetUrlTypes = GettingUrlAction | GetUrlSuccessAction | GetUrlErrorAction;

//#endregion

//#region Get instrument

export const GETTING_INSTRUMENT = "GETTING_INSTRUMENT";
export const GET_INSTRUMENT_SUCCESS = "GET_INSTRUMENT_SUCCESS";
export const GET_INSTRUMENT_ERROR = "GET_INSTRUMENT_ERROR";
export const CLEAR_INSTRUMENT = "CLEAR_INSTRUMENT";

export interface GettingInstrumentAction {
  type: typeof GETTING_INSTRUMENT;
}

export interface GetInstrumentSuccessAction {
  type: typeof GET_INSTRUMENT_SUCCESS;
  instrument: Instrument;
}

export interface GetInstrumentErrorAction {
  type: typeof GET_INSTRUMENT_ERROR;
  error: string;
}

export interface ClearInstrumentAction {
  type: typeof CLEAR_INSTRUMENT;
}

export type GetInstrumentTypes =
  | GettingInstrumentAction
  | GetInstrumentSuccessAction
  | GetInstrumentErrorAction
  | ClearInstrumentAction;

//#endregion

//#region  Get issuers

export const GETTING_ISSUERS = "GETTING_ISSUERS";
export const GET_ISSUERS_SUCCESS = "GET_ISSUERS_SUCCESS";
export const GET_ISSUERS_ERROR = "GET_ISSUERS_ERROR";

export interface GettingIssuersAction {
  type: typeof GETTING_ISSUERS;
}

export interface GetIssuersSuccessAction {
  type: typeof GET_ISSUERS_SUCCESS;
  issuers: Issuer[];
}

export interface GetIssuersErrorAction {
  type: typeof GET_ISSUERS_ERROR;
  error: string;
}

export type GetIssuersTypes = GettingIssuersAction | GetIssuersSuccessAction | GetIssuersErrorAction;

//#endregion

export type InstrumentTypes = GetInstrumentTypes | GetIssuersTypes;

export type AppActions = PurchaseDataTypes | PurchaseTypes | GetUrlTypes | GetInstrumentTypes | GeneratePaymentLinkType;
